import { Formik } from "formik";
import PropTypes from "prop-types";
import React from "react";
import { Form } from "react-bootstrap";
import * as yup from "yup";
import {useStakingContract, useStakingDispatch} from "../../context/StakingContract";
import {SET_STAKING_VALUE, SET_TOAPPROVE_ALLOWANCE, SHOW_STAKE} from "../../context/StakingContract/actions";

function isValidInt(number) {
  return !(
    isNaN(number) ||
    isNaN(parseInt(number.toString())) ||
    !/^\+?(0|[1-9]\d*)$/.test(number.toString())
  );
}

const AuthorizeForm = ({ nextStep, lastStep, minValue, currentStep, goToStep }) => {
  const {state} = useStakingContract();
  const dispatch = useStakingDispatch();

  const {staking, allowance} = state;
  // This is the maximum still available for stake in the contract
  const maxStake = staking.contractTotalStakeLimit - staking.contractTotalStake;
  // This is the maximum the user can stake: either the whole maxStake, either his entire balance
  const userCanStake = staking.stakingValue < maxStake ? staking.stakingValue : maxStake;
  const schema = yup.object({
    amount: yup
      .number()
      .default(userCanStake)
      .typeError("Invalid number")
      .test(
        "isValidInteger",
        "Invalid integer",
        value => value && isValidInt(value)
      )
      .test("min", `Must be higher than ${minValue}`, value => {
        return value >= minValue;
      })
      // .test("max", `Maximum stake exceeded`, value => {
      //   return value <= maxStake
      // })
      .required()
  });
  return (
    <Formik
      validationSchema={schema}
      onSubmit={values => {
        dispatch({type: SET_STAKING_VALUE, payload: parseInt(values.amount)});
        dispatch({type: SHOW_STAKE, payload: true});
        let diffToApprove = parseInt(values.amount) - allowance.existing;
        if ( diffToApprove <= 0 ) {
          dispatch({type: SET_TOAPPROVE_ALLOWANCE, payload: 0});
          goToStep(currentStep + 2);
          return;
        }

        dispatch({type: SET_TOAPPROVE_ALLOWANCE, payload: parseInt(values.amount)});
        nextStep();
      }}

      enableReinitialize
      initialValues={{
        amount: userCanStake
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors
      }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <Form.Group controlId="amount">
            <Form.Label>ERD Amount</Form.Label>
            <Form.Control
              type="amount"
              placeholder="Amount"
              name="amount"
              value={values.amount}
              onChange={handleChange}
              isInvalid={!!errors.amount}
            />
            <small className="form-text text-muted">
            </small>
            <small className="form-text text-muted">
              Maximum available in your wallet {staking.erdBalance.toLocaleString('en')} ERD
                {(userCanStake < staking.erdBalance) &&
                  <div>Maximum available to be staked {userCanStake.toLocaleString('en')} ERD</div>
                }
              </small>
            <Form.Control.Feedback type="invalid">
              {errors.amount}
            </Form.Control.Feedback>
          </Form.Group>
          <p className="mb-1">You will be notified, through Metamask, to sign two transactions in the next 2 steps:</p>
          <ul className="mb-4">
            <li>First transaction is the <strong>Pre-authorization</strong> step, where you allow the pre-staking contract to access your tokens upto the provided amount.</li>
            <li>Second transaction is the <strong>Stake</strong> step, where the provided amount of ERD tokens will be actually be staked in the contract.</li>
          </ul>
          <button className="btn btn-primary" type="submit">
            Continue
          </button>
        </Form>
      )}
    </Formik>
  );
};

AuthorizeForm.propTypes = {
  nextStep: PropTypes.func,
  minValue: PropTypes.number
};

const SelectAmount = ({ nextStep, lastStep, goToStep, currentStep }) => {
  return (
    <div className="card">
      <div className="card-body">
        <h3>How much do you want to stake?</h3>
        <p className="lead">Please enter the amount of ERD you want to stake. </p>
        <AuthorizeForm nextStep={nextStep} lastStep={lastStep} minValue={1} goToStep={goToStep} currentStep={currentStep} />
      </div>
    </div>
  );
};

export default SelectAmount;
